import {
  rols_cliente,
  rols_promotor,
  rols_administrador,
  rols_autor_por_encargo,
} from "../utils/utils";
import useCarritoStore from "@/store/carrito";

export const useUsuarioStore = defineStore("usuario", () => {
  const welcome_guia = ref(false);

  const usuario = ref({
    id: null,
    nombre: "",
    apellido: "",
    email: null,
    telefono: null,
    rol_id: null,
    avatar: null,
    activo: null,
    is_password: false,
    ultimo_login: null,
    estado_id: null,
    ciudad_id: null,
    direccion: "",
    locale: "es",
    cliente: null,
    invitaciones: [],
    entrevista_id: null,
    entrevista_inicio_terminada: false,
    plan_subscrito: null,
    suscripcion_vencida: false,
    paginas: 0,
    libros_terminados: 0,
    libros_pendientes: 0,
    slug: "",
    sinopsis_general: "",
    descuento_id: null,
    descuento: null,
    conectado: false,
  });

  const user = ref({
    id: null,
    nombre: "",
    apellido: "",
    email: null,
    telefono: null,
    rol_id: null,
    avatar: null,
    activo: null,
    is_password: false,
    ultimo_login: null,
    estado_id: null,
    ciudad_id: null,
    direccion: "",
    locale: "es",
    cliente: null,
    invitaciones: [],
    entrevista_id: null,
    plan_subscrito: null,
    suscripcion_vencida: false,
    entrevista_inicio_terminada: false,
    paginas: 0,
    libros_terminados: 0,
    libros_pendientes: 0,
    slug: "",
    sinopsis_general: "",
    descuento_id: null,
    descuento: null,
    conectado: false,
  });

  const conectados = ref([]);

  const usuarios = ref([]);
  const draft = computed(() => clone(user.value));
  const draftUsuario = computed(() => usuario.value);
  const descuentoPromotor = computed(() => {
    return usuario.value.descuento?.porcentaje || 0;
  })
  const rol_name = computed(() => {
    return usuario.value.rol ? usuario.value.rol.nombre : null;
  });

  const usuario_id = computed(() => {
    return usuario.value.id || null;
  });

  const conectado = computed(() => {
    return usuario.value.conectado || false;
  });

  const conPermiso = computed(() => {
    return (permiso) => {
      if (usuario.value.id) {
        return usuario.value.roles[0].permissions.find(
          (permission) => permission.name == permiso
        );
      }
      return false;
    };
  });

  const paginas_disponibles = computed(() => {
    return usuario.value.paginas || 0;
  });

  const isRol = computed(() => {
    return (rol) => {
      if (usuario.value.rol) {
        if (typeof rol === "object")
          return rol.includes(usuario.value.rol.nombre);
        return rol == usuario.value.rol.nombre;
      }
      return false;
    };
  });

  const getUsuarios = computed(() => {
    return (rol) => {
      return usuarios.value.filter((user) => {
        let i = user.value.roles.findIndex((role, i) => role.name == rol);
        if (i > 0) {
          return true;
        } else {
          return false;
        }
      });
    };
  });

  const isCliente = computed(() => isRol.value(rols_cliente));
  const isPromotor = computed(() => isRol.value(rols_promotor));
  const isPartner = computed(() => isRol.value(rols_promotor));
  const isAutorPorEncargo = computed(() => isRol.value(rols_autor_por_encargo));
  const isAdmin = computed(() => isRol.value(rols_administrador));
  const full_name = computed(() => {
    return `${usuario.value.nombre} ${usuario.value.apellido}`.trim();
  });

  // methods

  const clearUsuario = () => {
    user.value = {
      id: null,
      nombre: "",
      apellido: "",
      email: null,
      telefono: null,
      rol_id: null,
      avatar: null,
      activo: null,
      is_password: false,
      ultimo_login: null,
      estado_id: null,
      ciudad_id: null,
      direccion: "",
      locale: "es",
      cliente: null,
      invitaciones: [],
      entrevista_id: null,
      entrevista_inicio_terminada: false,
      slug: "",
      sinopsis_general: "",
      descuento_id: null,
      descuento: null,
      conectado: false,
    };
  };

  const limpiarUsuario = () => {
    usuario.value = {
      id: null,
      nombre: "",
      apellido: "",
      email: null,
      telefono: null,
      rol_id: null,
      avatar: null,
      activo: null,
      is_password: false,
      ultimo_login: null,
      estado_id: null,
      ciudad_id: null,
      direccion: "",
      locale: "es",
      cliente: null,
      invitaciones: [],
      entrevista_id: null,
      entrevista_inicio_terminada: false,
      slug: "",
      sinopsis_general: "",
      descuento_id: null,
      descuento: null,
      conectado: false,
    };
  };

  const descontarPaginas = (paginas_desc) => {
    if (usuario.value.id) {
      usuario.value.paginas -= paginas_desc;
      localStorage.setItem("userData", JSON.stringify(usuario.value));
    }
  };

  const actualizarPaginas = (paginas) => {
    if (usuario.value.id) {
      usuario.value.paginas = paginas;
      localStorage.setItem("userData", JSON.stringify(usuario.value));
    }
  };

  const cargarUser = (data) => {
    localStorage.setItem("userData", JSON.stringify(data));
    usuario.value = { ...usuario.value, ...data };
    if (usuario.value.carrito_id) {
      const carrito_store = useCarritoStore();
      carrito_store.fetch(usuario.value.carrito_id);
    }
  };

  const resetUser = () => {
    usuario.value = JSON.parse(localStorage.getItem("userData"));
  };

  const updateLocale = ({ usuario: user, locale }) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${user}/update-locale/${locale}`)
        .then(({ data }) => {
          if (data.result) {
            localStorage.setItem("locale", locale);
            usuario.value.locale = locale;
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const desactivarCuenta = (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/desactivar/usuario`, data)
        .then(({ data: datos }) => {
          const user = JSON.parse(localStorage.getItem("userData"));
          user.activo = !datos.result;
          localStorage.setItem("userData", JSON.stringify(user));
          usuario.value.activo = !datos.result;
          resolve(datos);
        })
        .catch((e) => reject(e));
    });
  };

  const updateAvatarUser = ({ user_id, imagen, tipo }) => {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("imagen", imagen);

      axios
        .post(`/api/usuario/${user_id}/update/avatar`, form, {
          headers: {
            "Content-Type": "multipart/form-data; boundary=something",
          },
        })
        .then(({ data }) => {
          if (data.result) {
            let avat = data.avatar;
            if (tipo == "user") {
              if (user.value.id === user_id) user.value.avatar = avat;
            }

            if (tipo == "usuario") {
              if (usuario.value.id === user_id) {
                cargarUser({ ...usuario.value, avatar: avat });
              }
            }
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const conectarUsuario = (u_id) => {
    if (usuario.value.id == u_id) {
      usuario.value.conectado = true;
    }

    let u = usuarios.value.find((us) => us.id == u_id);

    // verificar autor
    let aut_u = usuarios.value.find((us) => {
      if (us.usuario && us.usuario.id == u_id) {
        return us;
      }
    });

    if (u) {
      u.conectado = true;
      if (u.usuario) {
        u.usuario.conectado = true;
      }
    }

    if (aut_u) {
      aut_u.usuario.conectado = true;
    }

    if (user.value.id == u_id) {
      user.value.conectado = true;
    }

    conectados.value.push(u_id);
  };

  const desconectarUsuario = (u_id) => {
    if (usuario.value.id == u_id) {
      usuario.value.conectado = false;
    }

    let u = usuarios.value.find((us) => us.id == u_id);
    // verificar autor
    let aut_u = usuarios.value.find((us) => {
      if (us.usuario && us.usuario.id == u_id) {
        return us;
      }
    });

    if (u) {
      u.conectado = false;
      if (u.usuario) {
        u.usuario.conectado = false;
      }
    }

    if (aut_u) {
      aut_u.usuario.conectado = false;
    }

    if (user.value.id == u_id) {
      user.value.conectado = false;
    }

    conectados.value = conectados.value.filter((id) => id != u_id);
  };

  const usuarioConectado = (u_id) => {
    return conectados.value.includes(u_id);
  };

  const updatePerfil = (data) => {
    localStorage.setItem("userData", JSON.stringify(data));
    if (data.habilidades) {
      localStorage.setItem("habilidades", JSON.stringify(data.habilidades));
    }
    usuario.value = { ...usuario.value, ...data };
  };

  const finalizarEntrevistaInicio = (user_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${user_id}/finalizar-entrevista-inicio`)
        .then(({ data }) => {
          if (data.result) {
            let userData = JSON.parse(localStorage.getItem("userData"));
            userData.entrevista_inicio_terminada = true;
            updatePerfil(userData);
          }
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const guardarUsuario = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/perfil/update/usuario/${datos.id}`, datos)
        .then(({ data }) => {
          if (data.result) {
            updatePerfil(data.usuario);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const refetchUsuario = (user_id) => {
    return new Promise((resolve, reject) => {
      if (user_id) {
        axios
          .get(`/api/perfil/${user_id}/refetch-user`)
          .then(({ data }) => {
            if (data.result) {
              updatePerfil(data.usuario);
            }
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        reject(new Error("User ID is required to refetch user data"));
      }
    });
  };

  const cambiarContrasena = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/cambiar/contrasena/usuario/${usuario.value.id}`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/usuarios/fetch-data", datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => reject(error));
    });
  };

  const fetch = (usuario_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${usuario_id}/fetch-data`)
        .then(({ data }) => {
          user.value = data;
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/usuarios/` + datos.id, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post("/api/usuarios", datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (usuario_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/usuarios/${usuario_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const cambiarStatus = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/usuarios/${datos.user_id}/change-status`, datos)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const verificarEstatus = (user_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${user_id}/verificar-estatus`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const nuevoUsuario = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/usuarios/nuevo-usuario`, datos)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchAmigos = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${usuario.value.id}/fetch-amigos`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const fetchColaboradores = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${usuario.value.id}/fetch-colaboradores`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const enviarInvitacion = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/usuarios/${usuario.value.id}/enviar-invitacion`, datos)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const traerSinopsisDesdeLibro = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/usuarios/${usuario.value.id}/traer-sinopsis-libro`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchPublicAutor = (slug) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/autors/${slug}/public/fetch-data`)
        .then(({ data }) => {
          if (data.id) {
            user.value = data;
            resolve(data);
          } else {
            reject(new Error("No se pudo obtener los datos del autor"));
          }
        })
        .catch((e) => reject(e));
    });
  };

  const actualizarDescuento = async ({ usuario_id, descuento_id }) => {
    if (!usuario_id) return;

    try {
      const { data } = await axios.put(
        `/api/usuarios/${usuario_id}/descuentos/actualizar`,
        { descuento_id }
      );
      if (data.result) {
        actualizarDescuento(data.usuario);
      }
      return data;
    } catch (error) {
      throw error;
    }
  };

  const obtenerDescuentoPromotor = async (promotor_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${promotor_id}/descuentos/fetch`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const fetchUltimoBalance = async (usuario_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${usuario_id}/fetch-ultimo-balance`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const fetchDataPromotor = async (promotor_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${promotor_id}/fetch-data-promotor`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const enviarMensajeSoporte = async (datos) => {
    try {
      const { data } = await axios.post(`/api/soporte/contacto`, datos);
      return data;
    } catch (error) {
      throw error;
    }
  };

  const obtenerActividadesRecientes = async (usuario_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${usuario_id}/actividades-recientes`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const mostrar_welcome_guia = () => {
    welcome_guia.value = true;
  };

  const cargarWelcomeGuia = () => {
    if (localStorage.getItem("welcome_guia_shown")) {
      welcome_guia.value = false;
    } else {
      localStorage.setItem("welcome_guia_shown", "true");
      mostrar_welcome_guia();
    }
  };

  const fetchSelectList = async (rol_name = "todos") => {
    try {
      const { data } = await axios.post(`/api/usuarios/fetch-select-list-rol`, {
        rol_name,
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

  const setUsuarios = (usrs) => {
    usuarios.value = usrs || [];
  };

  const verificarRememberMe = async (u_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${u_id}/verificar-remember-me`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const fetchUserLight = async (user_id) => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${user_id}/fetch-user-light`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  const getEncargosPendientesCount = async () => {
    try {
      const { data } = await axios.get(
        `/api/usuarios/${usuario.value.id}/encargos-pendientes-count`
      );
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    usuario,
    user,
    usuarios,
    draft,
    draftUsuario,
    conPermiso,
    getUsuarios,
    isCliente,
    isPromotor,
    isRol,
    paginas_disponibles,
    usuario_id,
    isAdmin,
    isPartner,
    isAutorPorEncargo,
    limpiarUsuario,
    cargarUser,
    updateLocale,
    desactivarCuenta,
    updateAvatarUser,
    resetUser,
    guardarUsuario,
    updatePerfil,
    cambiarContrasena,
    fetchAmigos,
    fetchColaboradores,
    fetchData,
    fetch,
    guardar,
    clearUsuario,
    eliminar,
    cambiarStatus,
    verificarEstatus,
    nuevoUsuario,
    enviarInvitacion,
    refetchUsuario,
    finalizarEntrevistaInicio,
    descontarPaginas,
    actualizarPaginas,
    traerSinopsisDesdeLibro,
    fetchPublicAutor,
    fetchSelectList,
    rol_name,
    full_name,
    actualizarDescuento,
    obtenerDescuentoPromotor,
    fetchUltimoBalance,
    fetchDataPromotor,
    enviarMensajeSoporte,
    obtenerActividadesRecientes,
    cargarWelcomeGuia,
    welcome_guia,
    mostrar_welcome_guia,
    conectado,
    conectarUsuario,
    desconectarUsuario,
    setUsuarios,
    verificarRememberMe,
    conectados,
    usuarioConectado,
    fetchUserLight,
    getEncargosPendientesCount,
    descuentoPromotor,
  };
});

export default useUsuarioStore;
